import setup from './moduleSetup';

export default {
    name: 'routes',
    before: [],
    after: [],
    setup,
};
